import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import transportIcon from "../../../../../assets/new-product-detail-cats/header-icons/prod-deliveries-icon.svg";
import { useTranslation } from "react-i18next";
import formatDate from "../../components/HeaderBox/formatDate";
import { getTransportation36Totals } from "../../../../../apis/Product/TransportationFlow36Api";

const Transportation36Icon = () => (
  <img src={transportIcon} alt="Transportation 36 Icon" width={76} height={76} />
);

const Transportation36Header = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalProdItem, setTotalProdItem] = useState(null);

  useEffect(() => {
    if (productId) {
      getTransportation36Totals({
        productId,
        setTotals: setTotalProdItem,
      });
    }
  }, [productId]);

  return (
    <CategoryComponent
      show={show}
      className={`transportation-36-category ${className || ""}`}
      leftBoxProps={{
        icon: <Transportation36Icon />,
        title: t("TRANSPORTATION_36") || "Transportation and deliveries between the manufacturing and installation/construction phases",
        description:
          t("TRANSPORTATION_36_DESC") ||
          "Transportation and deliveries between the manufacturing and installation/construction phases.",
        productId: productId,
        isSystemBoundary: false,
        customTextColor: "white",
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: "",
                subitems: [],
              },
            ],
            isSwitchable: true,
          },
          // {
          //   title: t("TOTAL_FOR_FLOW_36") || "Total for Flow 36",
          //   items: [
          //     {
          //       subtitle: "",
          //       subitems: [],
          //     },
          //   ],
          //   isSwitchable: true,
          // },
        ],
        impactTotals: totalProdItem?.impact_totals || null,
        lastUpdated: totalProdItem?.updated_at
          ? formatDate(totalProdItem?.updated_at)
          : t("DD_MM_YYYY"),
        customTextColor: "white",
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default Transportation36Header;

